const SERVER = process.env.REACT_APP_API_URL;
const routes = {
    processors: '/connector/processors', // maybe will be loaded in appparams
    list: '/connector/list',
    create: '/connector/create/',
    read: '/connector/get/',
    update: '/connector/update/',
    delete: '/connector/delete/',
    packages: '/connector/packages/',
    shippers: '/connector/shippers/',
    statuses: '/connector/order_statuses/',
    import: '/connector/bulk/',
    test: '/package/referencenumber/',
    payment_methods: '/connector/payment_methods/',
    filter: '/connector/filter/'
};

const getApiConnectorRoute = (name, params = [], isAdmin) => {
    return SERVER + '/api' + routes[name] + params.join('/');
}

export default getApiConnectorRoute;